import React from 'react';
import {
  Form, Input, Button
} from 'antd';
import PropTypes from 'prop-types';

const { TextArea } = Input;

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: '${label} est un champ requis!',
  types: {
    email: '${label} email invalide!',
  },
};

const SendCDC = ({ onFinish, loading }) => (
  <Form {...layout} name="nest-messages" onFinish={onFinish} validateMessages={validateMessages}>
    <Form.Item
      name={['user', 'name']}
      label="Nom / Société"
      rules={[
        {
          required: true,
        },
      ]}
    >
      <Input />
    </Form.Item>
    <Form.Item
      name={['user', 'email']}
      label="Email"
      rules={[
        {
          required: true,
        },
        {
          type: 'email',
        },
      ]}
    >
      <Input />
    </Form.Item>
    <Form.Item
      name={['user', 'phone']}
      label="Téléphone"
    >
      <Input />
    </Form.Item>
    <Form.Item
      name={['user', 'message']}
      label="Message"
    >
      <TextArea />
    </Form.Item>
    <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
      <Button type="primary" htmlType="submit" loading={loading}>
        Envoyer
      </Button>
    </Form.Item>
  </Form>
);

SendCDC.propTypes = {
  onFinish: PropTypes.func,
  loading: PropTypes.bool,
};

export default SendCDC;
